module.exports = __webpack_public_path__ + "img/deal_banner.29e127a7.png";